window.postGridBlog = () => {
    return{
        isLoading: false,
        visible: false,
        loadMore(){
            const postGrid = this.$el.closest('[data-pegasus-filterable]');
            const dataSelector = '[data-pegasus-filterable="'+postGrid.dataset.pegasusFilterable+'"]';
        
            const href = this.$el.getAttribute("href"),
                container = [dataSelector],
                elements = ['[data-pegasus-single-card]', '.Post__Grid-next-page'];

            if(!this.isLoading){
                this.isLoading = true;
                pegasus.loadMoreContent(href, container, elements, {}, () => {
                    this.isLoading = false;
                    this.$el.parentElement.remove();
                });
            }

        },
    }
}